/**
 * SectionFlash — セクション切り替え時の一瞬フラッシュエフェクト
 *
 * 削除方法（2ステップ）:
 *   1. Home.tsx の import 行を削除: import { SectionFlash } from "@/components/SectionFlash";
 *   2. Home.tsx の <SectionFlash /> を削除
 *   このファイル自体は残しておいても動作に影響しません。
 */
import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export function SectionFlash() {
  const [flashing, setFlashing] = useState(false);
  const lastScrollY = useRef(0);
  const lastSection = useRef<string | null>(null);
  const cooldown = useRef(false);

  useEffect(() => {
    const SECTION_IDS = ["hero", "about", "fields", "concept", "tech", "links", "contact"];

    /** 現在画面中央にいるセクションIDを返す */
    function getCurrentSection(): string | null {
      const cy = window.innerHeight / 2;
      for (const id of SECTION_IDS) {
        const el = document.getElementById(id) ?? document.querySelector(`section[id="${id}"]`);
        if (!el) continue;
        const rect = el.getBoundingClientRect();
        if (rect.top <= cy && rect.bottom >= cy) return id;
      }
      return null;
    }

    function handleScroll() {
      const current = getCurrentSection();
      if (current && current !== lastSection.current) {
        lastSection.current = current;
        if (!cooldown.current) {
          cooldown.current = true;
          setFlashing(true);
          setTimeout(() => setFlashing(false), 350);
          setTimeout(() => { cooldown.current = false; }, 800);
        }
      }
      lastScrollY.current = window.scrollY;
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {flashing && (
        <motion.div
          key="flash"
          initial={{ opacity: 0.18 }}
          animate={{ opacity: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="pointer-events-none fixed inset-0 z-[9999]"
          style={{
            background:
              "radial-gradient(ellipse at center, rgba(160,220,255,0.22) 0%, rgba(80,160,220,0.10) 40%, transparent 70%)",
          }}
        />
      )}
    </AnimatePresence>
  );
}
